// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Il3Yg","root":"Modal_root__auICm","defaultPadding":"Modal_defaultPadding__d02jP","wide":"Modal_wide__BNlg0","closeButton":"Modal_closeButton__HbaTM"};